export default function determineScreenRes() {
  if ($(window).width() >= 1000) {
    return 'desktop'
  } else if ($(window).width() >= 768) {
    return 'tablet'
  } else {
    return 'mobile'
  }
}
